/**
 * Derived from Open Science `apps/desktop/src/components/thread/InteractionPrompt.tsx`
 * at e2333ef9bdefb9c5438c54fc78d93fe56ec72ed0 (MIT).
 *
 * Cadence currently exposes project-scoped permission requests only. It does
 * not expose a ProjectTurn/request association or answerable questions, so
 * this component deliberately remains outside individual timeline turns.
 */
import { Check, ShieldQuestion, X } from "lucide-react";
import type { CadencePermissionRequest } from "./types";

export function ProjectInteractionPrompt({
  permissions,
  error,
  pendingRequestId,
  onDecision,
}: {
  permissions: CadencePermissionRequest[];
  error?: string;
  pendingRequestId?: string;
  onDecision?: (
    request: CadencePermissionRequest,
    decision: "approve" | "deny",
  ) => void;
}) {
  const request = permissions[0];
  if (!request && !error) return null;
  return (
    <aside
      className="composer-interaction-prompt"
      data-testid="composer-permission-prompt"
      aria-label="待处理的项目权限请求"
    >
      {request && (
        <>
          <ShieldQuestion size={16} aria-hidden="true" />
          <div className="composer-interaction-copy">
            <strong>{request.target}</strong>
            <span>{request.reason}</span>
            {permissions.length > 1 && <small>另有 {permissions.length - 1} 项待处理请求</small>}
          </div>
          {onDecision && (
            <div className="composer-interaction-actions">
              <button
                className="composer-interaction-deny"
                type="button"
                disabled={pendingRequestId === request.requestId}
                onClick={() => onDecision(request, "deny")}
              >
                <X size={14} aria-hidden="true" />
                拒绝
              </button>
              <button
                className="composer-interaction-approve"
                type="button"
                disabled={pendingRequestId === request.requestId}
                onClick={() => onDecision(request, "approve")}
              >
                <Check size={14} aria-hidden="true" />
                {pendingRequestId === request.requestId ? "保存中…" : "批准"}
              </button>
            </div>
          )}
        </>
      )}
      {error && <p role="alert">{error}</p>}
    </aside>
  );
}
